import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { spinnerSvgIcon } from '@assets/icons/icons';
import { ComponentUtilsService } from '@core/services';
import {
  customComponentListener,
  onFormFieldChangeType,
  selectBoxConfig,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { IconsComponent } from '@shared/components/icons/icon.component';

@Component({
  imports: [TranslateModule, IconsComponent, ReactiveFormsModule],
  standalone: true,
  selector: 'custom-selectbox-component',
  templateUrl: './selectbox.component.html',
  styleUrls: ['./selectbox.component.scss'],
})
export class CustomSelectBoxComponent {
  @Input({ required: true }) config!: selectBoxConfig;

  @Input({ required: false }) listeners!: customComponentListener[];

  @Output() onFormFieldChange = new EventEmitter<onFormFieldChangeType>();

  protected selectBoxControl = new FormControl();

  private _value: any = undefined;

  @Input()
  set value(val: any) {
    if (val == this._value || val == undefined) return;

    if (this.config.type == 'data') {
      this._value = typeof val == 'object' ? val[this.config.keys.value] : val;
      this.selectBoxControl.setValue(this._value, { emitEvent: false });
    }

    if (this.config.type == 'base') {
      this._value = val;
      this.selectBoxControl.setValue(this._value, { emitEvent: false });
    }
  }

  protected spinnerIcon = spinnerSvgIcon;

  constructor(private utils: ComponentUtilsService) {}

  ngOnInit() {
    this.utils.attachListeners(this, this.listeners);

    this.selectBoxControl.valueChanges.subscribe((value) => {
      this.handleOptionSelected(value);
    });

    this.selectBoxControl.setValue(this._value || '');

    if (this.config.disabled) this.selectBoxControl.disable();
  }

  handleOptionSelected(value: any) {
    if (value == '')
      return this.onFormFieldChange.emit({
        field: this.config.fieldName,
        value: undefined,
      });

    if (this.config.type == 'data') {
      const key = this.config.keys.value;
      value = this.config.returnObject
        ? this.config.data!.find((data2: any) => data2[key] == value)
        : value;
    }

    if (this.config.type == 'base') {
      value = this.config.returnObject
        ? this.config.options.find((option: any) => option[value] == value)
        : value;
    }

    this.onFormFieldChange.emit({ field: this.config.fieldName, value: value });
  }

  getOptionLabel(option: any) {
    if (this.config.type !== 'data') return '';

    const labelKey = this.config.keys.label;

    if (!labelKey.includes('-') && !labelKey.includes('/')) {
      return option[labelKey] ?? '';
    }

    const groups = labelKey.split('-');

    const labels = groups.map((group) => {
      if (group.includes('/')) {
        const subKeys = group.split('/');
        const subLabel = subKeys
          .map((subKey) => option[subKey]?.toString().trim() ?? '')
          .filter(Boolean)
          .join(' ');
        return subLabel.trim();
      }

      return option[group]?.toString().trim() ?? '';
    });

    return labels.filter(Boolean).join(' - ');
  }
}
